import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(({ palette }) => ({
  '@global': {
    '.MuiAutocomplete-option[data-focus="true"]': {
      background: 'transparent !important',
    },
    '.MuiAutocomplete-option[aria-selected="true"]': {
      background: 'transparent !important',
    },
    '.MuiAutocomplete-option:hover': {
      background: `${palette.primary.extraLight} !important`,
    },
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    background: palette.background.default,
  },
}))

export default useStyles
